import * as T from './types'
import * as API from 'src/api/dev/wxplatform'

export default {
    [T.CREATE_PLATFORM](store, params) {
        return API.createPlatform(params)
    },
    [T.GET_PLATFORM_INFO](store, params) {
        return API.getPlatformInfo(params)
    },
    [T.SAVE_PLATFORM_INFO](store, params) {
        return API.savePlatformInfo(params)
    },
    [T.GET_AUTHORITY_UTL](store, params) {
        return API.getAuthorityUrl(params)
    },
    [T.GET_WX_TEMPLATE_LIST](store, params) {
        return API.getWxTemplateList(params)
    },
    [T.USE_TEMPLATE](store, params) {
        return API.useTemplate(params)
    },
    [T.GET_DOMAINS](store, params) {
        return API.getDomains(params)
    },
    [T.RESET_DOMAINS](store, params) {
        return API.resetDomains(params)
    },
    [T.GET_DOMAIN_COUNTS](store, params) {
        return API.getDomainCounts(params)
    },
    [T.GET_CONFIG](store, params) {
        return API.getConfig(params)
    },
    [T.SET_CONFIG](store, params) {
        return API.setConfig(params)
    },
    [T.GET_PAGES](store, params) {
        return API.getPages(params)
    },
    [T.GET_CATEGORY](store, params) {
        return API.getCategory(params)
    },
    [T.SUBMIT_AUDIT](store, params) {
        return API.SubmitAudit(params)
    },
    [T.GET_MINIPROGRAMLIST](store, params) {
        return API.getMiniProgramList(params)
    },
    [T.GET_TICKET](store, params) {
        return API.getTicket(params)
    }
}
